import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import layoutConstants from '../constants/layout-constants';
import constants from '../../../../common/constants';
import CookiesWrapper from '../../../../common/cookies-wrapper';
import { setTabs, getAccountManagerInfo, getNews, toggleMenu } from '../actions/layout-actions';
// import AccountManagerInfoBox from './account-manager-info-box';
// import NoticesBox from './notices-box';
// import RenderIf from '../../../shared/render-if/components/render-if';

import '../styles/side-menu.css';

class SideMenu extends Component {
  componentDidMount() {
    const { location, setTabs } = this.props;

    if (location && location.pathname) {
      const item = _.find(layoutConstants.menu_items, menuItem => {
        return location.pathname === menuItem.path || location.pathname.indexOf(menuItem.value) > -1 || _.find(menuItem.tabs, { path: location.pathname });
      });

      if (item) {
        setTabs(item.tabs);
      }
    }

    // if (!accountManagerInfo) {
    //   getAccountManagerInfo();
    // }

    // if (!news) {
    //   getNews();
    // }
  }

  isMenuItemActive(item) {
    const { location } = this.props;

    return location && location.pathname && (location.pathname === item.path || location.pathname.indexOf(item.value) > -1);
  }

  handleMenuItemClick(item, uiBlocked) {
    if (uiBlocked && !item.isUnblocked) {
      return;
    }

    const { setTabs, toggleMenu, showMenu } = this.props;

    toggleMenu(!showMenu);

    if (item.path) {
      setTabs(item.tabs || null);
      browserHistory.push(item.path);
      return;
    }

    this.handleCallbacks(item);
  }

  handleCallbacks(item) {
    switch (item.callback) {
      case layoutConstants.menu_item_callbacks.legal_documentation:
        window.open(`${constants.naga_markets_landing_url}legal-documentation/`, '_blank');
        break;
      default:
        CookiesWrapper.removeCookie(constants.cookie_key_word);
        window.location.href = '/login';
        break;
    }
  }

  renderMenuItems(items, uiBlocked) {
    const { t } = this.context;

    if (items && items.length > 0) {
      return items.map((item, index) => {
        return (
          <div key={index} className={`side-menu-container__wrapper ${this.isMenuItemActive(item) ? 'menu-item-active' : ''} ${uiBlocked && !item.isUnblocked ? 'item-blocked' : ''}`} onClick={() => this.handleMenuItemClick(item, uiBlocked)}>
            <span className={`glyphicon ${item.icon}`} />
            <span className="text">{t(item.text)}</span>
          </div>
        );
      });
    } else return null;
  }

  filterMenuItems(items, profile) {
    const userType = profile && profile.user_type;

    if (items && items.length > 0) {
      return _.filter(items, item => {
        return (!item.user_types || item.user_types.indexOf(userType) > -1) && (!item.only_dev || !constants.is_prod_env);
      });
    } else return [];
  }

  render() {
    const { showMenu, profile, uiBlocked } = this.props;
    const menuItems = this.filterMenuItems(layoutConstants.menu_items, profile);

    return (
      <div className={`side-menu-container ${showMenu ? 'display-block-important' : ''}`}>
        {this.renderMenuItems(menuItems, uiBlocked)}
        <div className="side-menu-container__separator" />
        {/* <RenderIf if={accountManagerInfo}>
          <AccountManagerInfoBox />
        </RenderIf> */}
        {/* <div className="side-menu-container__separator" />
        <RenderIf if={news}>
          <NoticesBox />
        </RenderIf> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountManagerInfo: state.layoutReducer.accountManagerInfo,
  news: state.layoutReducer.news,
  showMenu: state.layoutReducer.showMenu,
  profile: state.userProfileReducer.profile,
  uiBlocked: state.layoutReducer.uiBlocked,
});

const mapDispatchToProps = dispatch => ({
  setTabs: tabs => {
    dispatch(setTabs(tabs));
  },
  getAccountManagerInfo: () => {
    dispatch(getAccountManagerInfo());
  },
  getNews: () => {
    dispatch(getNews());
  },
  toggleMenu: show => {
    dispatch(toggleMenu(show));
  },
});

SideMenu.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/app/main/layout/components/side-menu.js